import { graphql } from 'gql.tada';
import { useQuery } from '@apollo/client';

// Ruling 30: the card fee follows the method used, so the parent sees what a
// given saved method will cost before confirming. Priced for one invoice and
// one method; nothing is written.
const InvoicePaymentQuoteQuery = graphql.persisted(
  "InvoicePaymentQuote",
  graphql(`
    query InvoicePaymentQuote($invoiceId: ID!, $paymentMethodId: ID!) {
      invoicePaymentQuote(invoiceId: $invoiceId, paymentMethodId: $paymentMethodId) {
        amountCents
        feeCents
        totalCents
        paymentMethodType
        description
      }
    }
  `)
);

export { InvoicePaymentQuoteQuery };

// Skipped until both halves are known; a quote is only meaningful for a chosen
// method. Read fresh each time: the fee depends on the invoice's current lines.
export function useInvoicePaymentQuery(invoiceId?: string | null, paymentMethodId?: string | null) {
  return useQuery(InvoicePaymentQuoteQuery, {
    variables: { invoiceId: invoiceId!, paymentMethodId: paymentMethodId! },
    skip: !invoiceId || !paymentMethodId,
    fetchPolicy: 'network-only',
  });
}
